export default class FileUtils {
  
    static getMdiIconForExtension(extension: string) {
        let icon = "mdi-file-document-outline"
        switch (extension) {
            case ".pdf":
                {
                    icon = "mdi-file-pdf-outline"
                    break;
                }
            case ".png":
            case ".gif":
            case ".tiff":
            case ".jpg":
            case ".jpeg": 
                {
                    icon = "mdi-file-image-outline"
                    break;
                }
            case ".xls":
            case ".xlsx":
                {
                    icon = "mdi-microsoft-excel"
                    break;
                }
            case ".doc":
            case ".docx":
                {
                    icon = "mdi-microsoft-word"
                    break;
                }
            case ".ppt":
            case ".pptx":
                {
                    icon = "mdi-microsoft-powerpoint"
                    break;
                }
            case ".msg":
            case ".oft":
                {
                    icon = "mdi-microsoft-outlook"
                    break;
                }
        }
        return icon;
    }

    static cleanContentType(extension: string, contentType: string) {
        if (extension === ".msg" || extension === ".oft") {
            return "application/vnd.ms-outlook"
        } else {
           
          return contentType;
        }
    }
}